<template>
  <router-link :to="to" :target="target">
    <slot />
  </router-link>
</template>
<script>
import { ARTICLES_URL } from '@/modules/article/article.constants';

export default {
  name: 'DaraArticleLink',
  props: {
    id: {
      type: String,
      required: true,
    },
    slug: {
      type: String,
      default: '',
    },
    track: {
      type: String,
      default: null,
    },
    target: {
      type: String,
      default: '',
    },
    action: {
      type: String,
      default: 'view',
      validator(action) {
        return action && ['view', 'edit'].includes(action);
      },
    },
  },
  computed: {
    to() {
      if (this.slug) {
        if (this.track) {
          return {
            name: ARTICLES_URL.track.name,
            path: ARTICLES_URL.track.path,
            params: { id: this.id, track: this.track },
            query: { title: this.slug },
          };
        }
        return {
          name: ARTICLES_URL[this.action].name,
          path: ARTICLES_URL[this.action].path,
          params: { id: this.id },
          query: { title: this.slug },
        };
      }
      return {
        name: ARTICLES_URL[this.action].name,
        path: ARTICLES_URL[this.action].path,
        params: { id: this.id },
      };
    },
  },
};
</script>
